/**
 * @author    yewon@zumper.com (Yewon Lee)
 * @copyright Copyright (c) 2016, Padmapper
 */

import { IS_BROWSER } from '@zcode/env'

export const getUserAgent = () => {
  if (IS_BROWSER) {
    return (
      (typeof window !== 'undefined' &&
        window.navigator &&
        window.navigator.userAgent) ||
      ''
    )
  }
  return ''
}
